import Translations from '@/components/mixins/Translations'
import Vue from 'vue'

import '@/assets/js/modules/components/'
import '@/assets/js/modules/header-navigation/main.js'
import '@/assets/js/modules/horizontal-scroller.js'

Vue.mixin(Translations)
